
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_388_447)","stroke":"#00D4BD","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5.333 4.667a2.667 2.667 0 105.334 0 2.667 2.667 0 00-5.333 0zM4 14v-1.333A2.667 2.667 0 016.667 10h1M10 12a2 2 0 104 0 2 2 0 00-4 0zM13.467 13.467l1.2 1.2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_388_447"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    